import { SET_MEGAMENU_ROOT } from 'redux/modules/mega-menu/actions/types';

export default menuRoot => ({
  menuRoot,
  type: SET_MEGAMENU_ROOT,
});
